import React from "react";
import useTranslation from "../../../hooks/useTranslation";
import AddIcon from "@mui/icons-material/Add";
import { Skeleton } from "@mui/material";

const AllHomesSkeleton = () => {
  const { traduction } = useTranslation();
  return (
    <div className="relative  w-full  lg:w-2/3  h-48 bg-[#F9F9F9] rounded-md border border-[#E6E6E6] p-6 flex justify-between space-x-4 cursor-pointer">
      <div className="h-20 ml-4 ">
        <div className="w-[20px] h-[20px] rounded-full bg-[#D9D9D9] flex justify-center items-center">
          <img src="/svg/cube.svg" />
        </div>
        <div className="w-max h-10 border-l-2 border-dashed border-[#D9D9D9] mx-auto"></div>
        <div className="w-[20px] h-[20px] rounded-full bg-primary bg-opacity-20 flex justify-center items-center">
          <img src="/svg/locationIcon.svg" />
        </div>
      </div>
      <div className="w-full space-y-8">
        <div className="h-20 flex flex-col justify-between">
          <Skeleton width={100} variant="text" />
          <Skeleton width={145} variant="text" />
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="flex justify-between space-x-1 items-center">
            <img src="/svg/pieceIcon.svg" />
            <Skeleton width={10} variant="text" />
            <p className="text-xs text-[#707070] font-semibold">
              {traduction("pieces")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllHomesSkeleton;
